<template>
  <v-dialog :value="dialog" width="700" persistent>
    <v-card>
      <v-card-title class="title greyDarken3--text">
        {{
          $t('rms.confirmation.title')
        }}
      </v-card-title>
      <v-divider/>
      <v-card-text class="title">
        {{
          text != undefined ? text : $t('rms.confirmation.text')
        }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onConfirm" color="red" outline>
          {{
          $t('rms.buttons.yes')
          }}
        </v-btn>
        <v-btn @click="onCancel" color="grey" outline>
          {{
          $t('rms.buttons.no')
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirmation",
  props: ["dialog", "text"],
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style></style>
